export const font = {
  fontSize: 11,
  fontFamily: 'Montserrat',
  fontColor: '#333333',
};

export const options = {
  legend: {
    display: false,
  },
  maintainAspectRatio: false,
  responsive: true,
  elements: {
    point: {
      radius: 0,
      borderWidth: 2,
    },
  },
  tooltips: {
    enabled: false,
  },
  layout: {
    padding: {
      left: 0,
      top: 0,
      right: 0,
    },
  },
};

export const optionsRed = {
  ...options,
  scales: {
    xAxes: [{
      drawBorder: true,
      gridLines: {
        display: false,
        offsetGridLines: true,
      },
      type: 'time',
      distribution: 'series',
      source: 'labels',
      time: {
        unit: 'day',
        displayFormats: {
          day: 'MMM DD',
        },
      },
      ticks: {
        autoSkip: true,
        maxTicksLimit: 8,
        ...font,
        // fontColor: '#fff',
      },
    }],
    yAxes: [
      {
        id: 'A',
        position: 'right',
        afterFit(scaleInstance) {
          scaleInstance.width = 100; //eslint-disable-line
        },
        ticks: {
          ...font,
          padding: 23,
        },
      },
      {
        afterFit(scaleInstance) {
          scaleInstance.width = 0; //eslint-disable-line
        },
        gridLines: {
          display: false,
        },
        ticks: {
          display: false,
        },
        position: 'left',
      },
    ],
  },
};

export const optionsBlack = {
  ...options,
  scales: {
    xAxes: [{
      drawBorder: true,
      gridLines: {
        display: false,
      },
      type: 'time',
      time: {
        displayFormats: {
          quarter: 'DD MMM',
        },
      },
      ticks: {
        autoSkip: true,
        maxTicksLimit: 5,
        ...font,
        padding: 18,
        fontColor: '#fff',
      },
    }],
    yAxes: [
      {
        id: 'A',
        position: 'right',
        afterFit(scaleInstance) {
          scaleInstance.width = 100; //eslint-disable-line
        },
        ticks: {
          ...font,
          padding: 23,
        },
      },
      {
        gridLines: {
          display: false,
        },
        ticks: {
          display: false,
        },
        position: 'left',
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./src/utils/chartSettings.js